import { render, staticRenderFns } from "./DashInventory.vue?vue&type=template&id=db07edde&scoped=true&"
import script from "./DashInventory.vue?vue&type=script&lang=js&"
export * from "./DashInventory.vue?vue&type=script&lang=js&"
import style0 from "./DashInventory.vue?vue&type=style&index=0&id=db07edde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db07edde",
  null
  
)

export default component.exports